import { Checkbox, FormControlLabel, Grid, Switch } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { useNotification } from '../../../helpers/Notification';
import { LoadingWidget } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import SelectFieldEntVistasComponent from '../../entidad/ent_vistas/components/SelectFieldEntVistas';
import { savePermisosAction } from '../PermisosAction';

const FormPermisos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const permisosStore = Redux.useSelector((state) => state.permisos);
  const usuEntPerfilesStore = Redux.useSelector(
    (state) => state.usuEntPerfiles,
  );

  const activo = permisosStore.activo;

  const initData = {
    create: false,
    read: true,
    update: false,
    delete: false,
    report: false,
    isInicio: true,
    idVista: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idVista: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idVista: activo.vista.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!data.idVista || data.idVista === '') {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }

    if (await _validDataForm()) {
      setLoadingSave(true);
      let res = await savePermisosAction(
        { dispatch, notify },
        activo?.id,
        {
          idUsuEntPerfil: usuEntPerfilesStore.activo.id,
          ...data,
        },
        permisosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <SelectFieldEntVistasComponent
                value={data.idVista}
                onChange={(idVista) => {
                  _handleSetDataField(CONST.vista.idName, idVista);
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={data.isInicio}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.isInicio.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
                label="Mostra en el inicio"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <FormControlLabel
              label="Todos"
              control={
                <Checkbox
                  checked={
                    data.create &&
                    data.read &&
                    data.update &&
                    data.delete &&
                    data.report
                  }
                  indeterminate={
                    !data.create ||
                    !data.read ||
                    !data.update ||
                    !data.delete ||
                    !data.report
                  }
                  onChange={(event) => {
                    const d = {
                      ...data,
                      create: event.target.checked,
                      read: event.target.checked,
                      update: event.target.checked,
                      delete: event.target.checked,
                      report: event.target.checked,
                    };
                    setData(d);
                  }}
                />
              }
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
              <FormControlLabel
                label={CONST.create.label}
                control={
                  <Checkbox
                    checked={data.create}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.create.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
              />
              <FormControlLabel
                label={CONST.read.label}
                control={
                  <Checkbox
                    checked={data.read}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.read.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
              />
              <FormControlLabel
                label={CONST.update.label}
                control={
                  <Checkbox
                    checked={data.update}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.update.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
              />
              <FormControlLabel
                label={CONST.deleted.label}
                control={
                  <Checkbox
                    color="error"
                    checked={data.delete}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.deleted.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
              />
              <FormControlLabel
                label={CONST.report.label}
                control={
                  <Checkbox
                    checked={data.report}
                    onChange={(event) => {
                      _handleSetDataField(
                        CONST.report.name,
                        event.target.checked,
                      );
                    }}
                  />
                }
              />
            </Box>
          </div>
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormPermisos;
